import classNames from 'classnames';
import { ReactNode } from 'react';
import * as React from 'react';

import './Thumbnail.scss';

interface IProps {
  dockTemplate?: ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  fileUrl?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string | object;
}

const Thumbnail: React.FunctionComponent<IProps> = (props) => {
  const { size, dockTemplate, fileUrl, onClick, children, className } = props;

  const classes = classNames(
    {
      'thumbnail': true,
      [`thumbnail-${size}`]: true,
      'thumbnail-clickable': onClick,
    },
    className
  );

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={classes} onClick={onClick} style={{ backgroundImage: `url("${fileUrl}")` }}>
      {dockTemplate && (
        <div className="thumbnail-dock" onClick={stopPropagation}>
          {dockTemplate}
        </div>
      )}
      {children}
    </div>
  );
};

Thumbnail.defaultProps = {
  size: 'md',
};

export default Thumbnail;
